import React from "react";
import useReveal from "../hooks/useReveal";

export default function Fulfilment({ content = {} }) {
  const { ref, cls } = useReveal();
  const imgs = [content.fulfil_image_1, content.fulfil_image_2, content.fulfil_image_3].filter(Boolean);
  return (
    <section className="bg-white py-24">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center ${cls}`}>
        <div className="order-2 lg:order-1 grid grid-cols-3 gap-4">
          {imgs.map((src, i) => (
            <div
              key={i}
              className={`rounded-2xl overflow-hidden shadow-[0_18px_50px_rgba(20,30,55,0.16)] transition-transform duration-500 hover:-translate-y-2 ${
                i === 1 ? "mt-8" : ""
              }`}
            >
              <img src={src} alt={`Packaging ${i + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
        <div className="order-1 lg:order-2">
          <h2 className="gp-heading text-[2.3rem] sm:text-[2.7rem]">{content.fulfil_title || "Print and postage made effortless"}</h2>
          <p className="text-[#5a6b80] text-[1.12rem] leading-relaxed mt-5 max-w-[480px]">
            {content.fulfil_text || "Provide a fast, reliable gift voucher delivery service without ever lifting a finger."}
          </p>
          <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-8">
            {content.fulfil_cta || "Learn about fulfilment"}
          </a>
        </div>
      </div>
    </section>
  );
}
